// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#PDFViewer{\r\n    width: 100%;\r\n    height: 900px;\r\n    position: relative;\r\n}\r\n#PDFViewer webview,\r\n#PDFViewer iframe{\r\n    width: 100%;\r\n    height: 100%;\r\n    border: none;\r\n}\r\n#PDFViewer .results-loading{\r\n    transform: translate(-50%, -50%);\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    color: #999;\r\n    font-size: 17px;\r\n    text-align: center;\r\n}", ""]);
// Exports
module.exports = exports;
